import { Flex } from "@chakra-ui/layout";
import { useMemo } from "react";
import TagStatus from "ui/components/Tags/TagStatus";
import {
  StatusOrcamentoEnum,
  OrcamentoDto,
} from "core/features/orcamento/typings";
import moment from "moment";
import colors from "core/resources/theme/colors";

function useOrcamentosColumns() {
  return useMemo(() => {
    return [
      {
        title: "Data de criação",
        width: "200px",
        render: (original: OrcamentoDto) => (
          <Flex>{moment(original.createdAt).format("DD/MM/YYYY")}</Flex>
        ),
      },
      {
        title: "Descrição",
        width: "550px",
        render: (original: OrcamentoDto) => <Flex>{original.descricao}</Flex>,
      },
      {
        title: "Quantidade de orçamentos",
        render: (original: OrcamentoDto) => (
          <Flex>{original.quantidadeOrcamento}</Flex>
        ),
      },
      {
        title: "Status",
        width: "300px",
        render: (original: OrcamentoDto) => (
          <Flex>
            {original.status.id === StatusOrcamentoEnum.Aprovado ? (
              <TagStatus color={colors.green500} status="Aprovado" />
            ) : original.status.id ===
              StatusOrcamentoEnum.ConsultaFornecedor ? (
              <TagStatus color="orange" status="Em consulta de fornecedor" />
            ) : original.status.id === StatusOrcamentoEnum.PendenteAprovacao ? (
              <TagStatus color="red" status="Pendente de aprovação" />
            ) : (
              <TagStatus color="orange" status="Pendente" />
            )}
          </Flex>
        ),
      },
    ];
  }, []);
}

export default useOrcamentosColumns;
